import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabase";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Alert,
} from "@mui/material";

export default function SetPassword() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handleSetPassword = async () => {
    if (!password) {
      setError("Please enter a new password.");
      return;
    }

    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setError(error.message);
      setSuccess("");
    } else {
      setSuccess("Password set successfully! Redirecting to login...");
      setError("");
      setTimeout(() => navigate("/"), 2000);
    }
  };

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f9f9f9",
          textAlign: "center",
          px: 2,
        }}
      >
        <Container maxWidth="xs" sx={{ overflow: "auto", py: 4 }}>
          <img
            src="https://cdn.shopify.com/s/files/1/0261/6318/3691/files/Maniko_logo.png?v=1693840112"
            alt="MANIKO Logo"
            style={{ width: "220px", marginBottom: "16px" }}
          />

          <Typography
            variant="body1"
            sx={{ color: "#888", mb: 4, fontSize: "1.1rem" }}
          >
            Please set a new password below.
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 3, fontSize: "1rem" }}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mb: 3, fontSize: "1rem" }}>
              {success}
            </Alert>
          )}

          <TextField
            type="password"
            placeholder="Enter your new password"
            variant="standard"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              disableUnderline: false,
            }}
            sx={{
              mb: 4,
              "& .MuiInputBase-input": {
                fontSize: "1.1rem",
              },
            }}
          />

          <Button
            fullWidth
            onClick={handleSetPassword}
            sx={{
              backgroundColor: "#121212",
              color: "white",
              borderRadius: 2,
              py: 2,
              fontSize: "1.1rem",
              textTransform: "none",
              fontWeight: 600,
              transition: "all 0.3s ease",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              "&:hover": {
                background: "linear-gradient(90deg, #d5d5d5 0%, #ffffff 100%)",
                color: "#000",
                transform: "scale(1.03)",
                boxShadow: "0 6px 18px rgba(0, 0, 0, 0.2)",
              },
            }}
          >
            Save Password
          </Button>
        </Container>
      </Box>
    </>
  );
}
